/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { getOntologyPortalUrl } from '@coze-common/ontology';

/** ABR 新版路由前缀：默认根路径，旧版使用 /v1 */
export const ABR_ROUTE_PREFIX = '';

export const COZE_V1_ROUTE_PREFIX = '/v1';

export const ABR_ONTOLOGY_PORTAL_URL = getOntologyPortalUrl();

export const ABR_INTEGRATION_PORTAL_URL = 'https://newone.leandc.cn';

export const ABR_DEVELOP_PATH = 'develop';

/** 全局应用商店路由 */
export const ABR_APP_STORE_PATH = '/apps';

export const ABR_APP_STORE_SUB_MENU_KEY = 'app-store';

export enum AbrSpaceSubModuleEnum {
  DEVELOP = 'develop',
  LIBRARY = 'library',
  DOCUMENT_WORKSPACE = 'document-workspace',
}

/** 全局编程会话路由 */
export const ABR_CODING_SESSIONS_PATH = '/coding-sessions';

export const ABR_CODING_SESSIONS_SUB_MENU_KEY = 'coding-sessions';
